import { useEffect, useState } from "react";
import api from "../lib/api";
import PageHeader from "../components/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Bell, WarningCircle } from "@phosphor-icons/react";
import { Semaforo } from "../components/Semaforo";

export default function Alerts() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/alerts").then((r) => setItems(r.data)); }, []);

  const groups = {
    critical: items.filter(i => i.alert_level === "critical"),
    urgent: items.filter(i => i.alert_level === "urgent"),
    warning: items.filter(i => i.alert_level === "warning"),
  };

  return (
    <div data-testid="alerts-page">
      <PageHeader title="Alertas" description="Compromisos próximos a vencer (30/15/7/3/1 día) y compromisos vencidos. Configurables por responsable." />
      <div className="p-6 grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Group title="Críticas / Vencidas" data={groups.critical} sem="rojo" icon={WarningCircle} />
        <Group title="Urgentes (≤ 7 días)" data={groups.urgent} sem="amarillo" icon={Bell} />
        <Group title="Próximas (≤ 30 días)" data={groups.warning} sem="amarillo" icon={Bell} />
      </div>
    </div>
  );
}

function Group({ title, data, sem, icon: Icon }) {
  return (
    <Card className="rounded-md shadow-sm">
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span className="flex items-center gap-2 text-base"><Icon size={16} /> {title}</span>
          <span className="text-xs font-normal text-slate-500">{data.length}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {data.length === 0 ? (
          <div className="p-6 text-sm text-slate-500">Sin alertas.</div>
        ) : (
          <ul className="divide-y divide-slate-100">
            {data.map(a => (
              <li key={a.id} className="px-4 py-3">
                <div className="flex items-center justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-medium text-sm truncate">{a.name}</div>
                    <div className="text-xs text-slate-500">{a.responsable_interno || "Sin responsable"} · {a.tipo}</div>
                  </div>
                  <div className="text-right">
                    <Semaforo value={sem} />
                    <div className="text-xs text-slate-500 mt-1">
                      {a.days_remaining < 0 ? `vencido hace ${-a.days_remaining}d` : `en ${a.days_remaining}d`}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
